import axios from '../context-api/axios';
import { LOGOUT_BRANCH_API } from '../context-api/ApiUrl';
import { localStorageKeys } from './constants';
import { clearRegBranchOnLoadCache } from './regBranchOnLoadCache';
import { getStoredAccessToken } from './regBranchOnLoadPayload';

/**
 * POST /LogoutBranch with current JWT (via interceptor) before local session is cleared.
 * Failures are ignored so logout always completes locally.
 */
export async function requestLogoutBranch() {
  if (!getStoredAccessToken()) return;
  try {
    await axios.post(
      LOGOUT_BRANCH_API,
      {},
      { headers: { 'Content-Type': 'application/json' } }
    );
  } catch {
    /* ignore — still clear client session */
  }
}

/**
 * Clears persisted auth, encrypted on-load cache, and axios Bearer.
 * Navigation is left to the caller (e.g. `navigate('/login')`).
 */
export function clearBranchSessionStorage() {
  const { TOKEN, REFRESH_TOKEN, LOGIN_INFO } = localStorageKeys;
  clearRegBranchOnLoadCache();
  try {
    localStorage.removeItem(LOGIN_INFO);
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
  } catch {
    /* ignore */
  }
  delete axios.defaults.headers.common.Authorization;
}
